import React from 'react';
import { Mail, Clock, MessageSquare } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#0D0D0D] pt-20">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-[#0D0D0D] to-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <span className="text-[#C9A962] text-sm uppercase tracking-widest">Get in Touch</span>
            <h1 className="heading-hero mt-4 mb-6">
              Let's <span className="text-[#C9A962]">Work Together</span>
            </h1>
            <p className="body-large">
              Ready to bring your script to life? Fill out the form below with your project 
              details and Joy will get back to you within 24-48 hours.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 md:py-24 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Contact Info */}
            <div className="lg:col-span-1 space-y-8">
              <div>
                <h2 className="heading-2 mb-6">Contact Information</h2>
                <p className="body-medium text-[#707070]">
                  Have a project in mind? Let's discuss how Joy's voice can elevate your brand.
                </p>
              </div>

              {/* Info Cards */}
              <div className="space-y-4">
                <div className="bg-[#161616] border border-[#1A1A1A] rounded-xl p-5 hover:border-[#C9A962]/20 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#C9A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Mail size={20} className="text-[#C9A962]" />
                    </div>
                    <div>
                      <h4 className="text-white font-medium mb-1">Email</h4>
                      <a 
                        href="mailto:hello@joyogbekene.com" 
                        className="text-[#B8B8B8] text-sm hover:text-[#C9A962] transition-colors"
                      >
                        hello@joyogbekene.com
                      </a>
                    </div>
                  </div>
                </div>

                <div className="bg-[#161616] border border-[#1A1A1A] rounded-xl p-5 hover:border-[#C9A962]/20 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#C9A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Clock size={20} className="text-[#C9A962]" />
                    </div>
                    <div>
                      <h4 className="text-white font-medium mb-1">Response Time</h4>
                      <p className="text-[#B8B8B8] text-sm">Within 24-48 hours</p>
                    </div>
                  </div>
                </div>

                <div className="bg-[#161616] border border-[#1A1A1A] rounded-xl p-5 hover:border-[#C9A962]/20 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-[#C9A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <MessageSquare size={20} className="text-[#C9A962]" />
                    </div>
                    <div>
                      <h4 className="text-white font-medium mb-1">What to Expect</h4>
                      <p className="text-[#B8B8B8] text-sm">
                        Quote within 24 hours, custom audition available upon request
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Tips */}
              <div className="bg-[#161616]/50 border border-[#1A1A1A] rounded-xl p-6">
                <h4 className="text-[#C9A962] text-sm uppercase tracking-wider mb-4">
                  For Faster Quotes
                </h4>
                <ul className="space-y-3 text-[#707070] text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-[#C9A962]">•</span>
                    Include your script or word count
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#C9A962]">•</span>
                    Specify usage rights needed
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#C9A962]">•</span>
                    Mention your deadline
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#C9A962]">•</span>
                    Share reference audio if available
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <div className="bg-[#161616] border border-[#1A1A1A] rounded-2xl p-8">
                <h3 className="heading-2 mb-2">Request a Quote</h3>
                <p className="body-small mb-8">
                  Fill out the form below and Joy will respond with a custom quote for your project.
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
